import { AddingAdditionalParcelCmp } from '@/components/features/parcels/creation/AddingAdditionalParcelCmp'
import { useParams } from '@tanstack/react-router'
import { PageContainer } from '@/components/features/shared/PageContainer'

export const AddingAdditionalParcelPage = () => {
  const { contractId, parcelId } = useParams({ strict: false }) as { contractId: string, parcelId: string }

  return (
    <PageContainer>
      <AddingAdditionalParcelCmp contractId={contractId} parcelId={parcelId} />
    </PageContainer>
  )
}
